// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"538":"8047e1fb","648":"757677ab","966":"09452f9f"}[chunkId] + ".chunk.js";
};